
<div class="row">
  
    <div class="col-12" style="height: 90vh !important; overflow: auto;">
   
          <div class="row pt-2">
            <div class="col-12">
           
              <div class="row">
                <div class="col-12" *ngIf="MajorTopic" style="overflow: scroll;min-height: 80vh !important;max-height:  60vh;height: 60vh;margin-right:2px;">
                  <table class="table  table-bordered  table-responsive table-sm">
                    <col>
                    <colgroup span="2"></colgroup>
                    <colgroup span="2"></colgroup>
                    <thead>
                    <tr class="table-secondary table-bordered border-secondary">
                      <th rowspan="2" class="col-md-5 xymiddle tableheaderlabel">Concepts</th>
                      <th rowspan="2" class="col-md-1 xymiddle tableheaderlabel">Include Questions With Images</th>
                      <th colspan="2" scope="col-md-2 colgroup" class="xmiddle tableheaderlabel">No of Questions</th>
                      <th colspan="2" scope="col-md-2 colgroup" class="xmiddle tableheaderlabel">Difficulty Range</th>
                      <th rowspan="2" class="col-md-2 xymiddle tableheaderlabel">Testing probability</th>                   
                    </tr>
                    <tr class="table-secondary table-bordered border-secondary">
                      <th scope="col" class="tableheaderlabel">Minimum</th>
                      <th scope="col" class="tableheaderlabel">Maximum</th>
                      <th scope="col" class="tableheaderlabel">Lower Range</th>
                      <th scope="col" class="tableheaderlabel">Upper Range</th>
                    </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                      <!-- <tr *ngFor="let MT of MajorTopic;let i=index"> -->

                    <div class="row tree-row" *ngFor="let MT of MajorTopic;let i=index"
                      >
                     
                  
                        <div class="col-5 d-flex">
                          
                         
                          <div class="px-1 tree-btn-1">
                           <button type="button" class="tree-btn" attr.id="plusMT{{i}}" [hidden]="MT.ChildNodeExistInd === 'N'"
                               [disabled]="MT.Study_Unit_Ind=='Y'"(click)="getsubjectData(MT.ID,'C',i)">
                             <i class="fa fa-angle-right" *ngIf="!MT.Data"></i><i class="fa fa-angle-down"  *ngIf="MT.Data"></i>
                           </button>
                         </div>
                         <div class="px-1 tree-btn-1" >
                          <!-- *ngIf="MT.ChildNodeExistInd === 'Y'" -->
                             <input type="checkbox"  [ngClass]="{'orange' : (MT.Exam_Instance_Concept_Exists_Ind=='Y' && MT.Study_Unit_Ind=='N')}" [disabled]="MT.Exam_Instance_Concept_Exists_Ind=='Y' && MT.Study_Unit_Ind=='N'" [checked]="MT.Study_Unit_Ind=='Y'"   (click)="checkbox(MT.ID,'C',i)"  class="form-check-input chkbx-size">
                           </div>
                         <app-tree-content Text="{{MT.Name}}" status="{{MT.Status_Code}}" ID="{{MT.ID}}"
                           ></app-tree-content>
                           <div class="px-1  tree-btn-1"  *ngIf="MT.Study_Unit_Ind=='Y'">
                            <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(MT)">
                                <i class="fa fa-edit" title="Edit"></i>
                            </button>
                          </div>
                          <div class="px-1  tree-btn-1"  *ngIf="MT.Study_Unit_Ind=='Y'">
                            <button type="button" class="tree-btn" (click)="DeleteConceptpopup(MT)">
                                <i class="fa fa-trash" title="Delete"></i>
                            </button>
                          </div>

                       </div>
                  
                       <div class="col-1 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'">
                        <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="MT.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                      </div>
                      <div  class="col-1 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'" >
                        {{MT.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                      
                      </div>
                      <div  class="col-1 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'" >
                        {{MT.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                        
                      </div>
                      <div class="col-1 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'">
                        {{MT.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                      </div> 
                      <div class="col-1 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'">
                        {{MT.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                      </div>
                      
                      <div class="col-2 xmiddle" *ngIf="MT.Study_Unit_Ind=='Y'">
                        {{MT.ExamInstanceConcept.Testing_Probability_Type_Code}}
                      </div>
                     
                      
                     
                      
                       
             
                        
                     

                    

                   

                      
                       <div class="col-12" *ngIf="MT.Data">
                          <div class="row tree-row tree-row-child" *ngFor="let C of MT.Data;let j =index;">
                            <div class="col-5 d-flex">
                              <div class="px-1 tree-btn-1">
                                <button type="button" class="tree-btn" (click)="getsubjectData(C.ID,'SC1',i,j)" attr.id="plusC{{i}}"
                                [disabled]="C.Study_Unit_Ind=='Y'" [hidden]="C.ChildNodeExistInd === 'N'">
                                  <i class="fa fa-angle-right" *ngIf="!C.Data"></i><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                                </button>
                              </div>
                              <div class="px-1 tree-btn-1" >
                                <!-- *ngIf="C.ChildNodeExistInd === 'Y'" -->
                                <input type="checkbox" [ngClass]="{'orange' : (C.Exam_Instance_Concept_Exists_Ind=='Y' && C.Study_Unit_Ind=='N')}"  [disabled]="C.Exam_Instance_Concept_Exists_Ind=='Y' && C.Study_Unit_Ind=='N'" (click)="checkbox(C.ID,'SC1',i,j)" [checked]="C.Study_Unit_Ind=='Y'" class="form-check-input chkbx-size">
                              </div>
                              <app-tree-content Text="{{C.Name}}" status="{{C.Status_Code}}" ID="{{C.ID}}"
                                >
                              </app-tree-content>
                              <div class="px-1  tree-btn-1"  *ngIf="C.Study_Unit_Ind=='Y'">
                                <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(C)">
                                    <i class="fa fa-edit" title="Edit"></i>
                                </button>
                              </div>
                              <div class="px-1  tree-btn-1"  *ngIf="C.Study_Unit_Ind=='Y'">
                                <button type="button" class="tree-btn" (click)="DeleteConceptpopup(C)">
                                    <i class="fa fa-trash" title="Delete"></i>
                                </button>
                              </div>
                            </div>
                            
                       <div class="col-1 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'">
                        <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="C.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                      </div>
                      <div  class="col-1 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'" >
                        {{C.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                      
                      </div>
                      <div  class="col-1 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'" >
                        {{C.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                        
                      </div>
                      <div class="col-1 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'">
                        {{C.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                      </div> 
                      <div class="col-1 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'">
                        {{C.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                      </div>
                      
                      <div class="col-2 xmiddle" *ngIf="C.Study_Unit_Ind=='Y'">
                        {{C.ExamInstanceConcept.Testing_Probability_Type_Code}}
                      </div>
                                    
                              
                           
                          
                          
                   
                          
                          <div class="col-12" *ngIf="C.Data">
                            <div class="row tree-row tree-row-child" *ngFor="let SC1 of C.Data;let k = index"
                              >
                              <div class="col-5">
                                    <div class="d-flex">
                                <div class="px-1 tree-btn-1">
                                  <button type="button" (click)="getsubjectData(SC1.ID,'SC2',i,j,k)" attr.id="plusSC1{{i}}"
                                  [disabled]="SC1.Study_Unit_Ind=='Y'" class="tree-btn" [hidden]="SC1.ChildNodeExistInd === 'N'">
                                    <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i><i class="fa fa-angle-down"
                                      *ngIf="SC1.Data"></i>
                                  </button>
                                </div>
                                <div class="px-1 tree-btn-1">
                                    <input type="checkbox" [ngClass]="{'orange' : (SC1.Exam_Instance_Concept_Exists_Ind=='Y' && SC1.Study_Unit_Ind=='N')}"  [disabled]="SC1.Exam_Instance_Concept_Exists_Ind=='Y' && SC1.Study_Unit_Ind=='N'" [checked]="SC1.Study_Unit_Ind=='Y'" (click)="checkbox(SC1.ID,'SC2',i,j,k)" class="form-check-input chkbx-size">
                                  </div>
                                <app-tree-content Text="{{SC1.Name}}" status="{{SC1.Status_Code}}" ID="{{SC1.ID}}"
                                  ></app-tree-content>
                                  <div class="px-1  tree-btn-1"  *ngIf="SC1.Study_Unit_Ind=='Y'">
                                    <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC1)">
                                        <i class="fa fa-edit" title="Edit"></i>
                                    </button>
                                  </div>
                                  <div class="px-1  tree-btn-1"  *ngIf="SC1.Study_Unit_Ind=='Y'">
                                    <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC1)">
                                        <i class="fa fa-trash" title="Delete"></i>
                                    </button>
                                  </div>
                                 
                              </div>
                              </div>
                              <div class="col-1 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'">
                                <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC1.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                              </div>
                              <div  class="col-1 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'" >
                                {{SC1.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                              
                              </div>
                              <div  class="col-1 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'" >
                                {{SC1.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                
                              </div>
                              <div class="col-1 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'">
                                {{SC1.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                              </div> 
                              <div class="col-1 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'">
                                {{SC1.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                              </div>
                              
                              <div class="col-2 xmiddle" *ngIf="SC1.Study_Unit_Ind=='Y'">
                                {{SC1.ExamInstanceConcept.Testing_Probability_Type_Code}}
                              </div>
                                       
                                       
                                      

                              <div class="col-12" *ngIf="SC1.Data">
            
                                <div class="row tree-row tree-row-child" *ngFor="let SC2 of SC1.Data;let l=index"
                                  >
                                  <div class="col-5">
                                      <div class="d-flex">
                                    <div class="px-1 tree-btn-1">
                                      <button type="button" class="tree-btn" (click)="getsubjectData(SC2.ID,'SC3',i,j,k,l)"
                                      [disabled]="SC2.Study_Unit_Ind=='Y'" attr.id="plusSC2{{i}}" [hidden]="SC2.ChildNodeExistInd === 'N'">
                                        <i class="fa fa-angle-right" *ngIf="!SC2.Data"></i>
                                        <i class="fa fa-angle-down" *ngIf="SC2.Data"></i>
                                      </button>
                                    </div>
                                    <div class="px-1 tree-btn-1">
                                        <input type="checkbox" [ngClass]="{'orange' : (SC2.Exam_Instance_Concept_Exists_Ind=='Y' && SC2.Study_Unit_Ind=='N')}"  [disabled]="SC2.Exam_Instance_Concept_Exists_Ind=='Y' && SC2.Study_Unit_Ind=='N'" (click)="checkbox(SC2.ID,'SC3',i,j,k,l)" [checked]="SC2.Study_Unit_Ind=='Y'" class="form-check-input chkbx-size">
                                      </div>
                                    <app-tree-content Text="{{SC2.Name}}" status="{{SC2.Status_Code}}" ID="{{SC2.ID}}"
                                      >
                                    </app-tree-content>
                                    <div class="px-1  tree-btn-1"  *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC2)">
                                          <i class="fa fa-edit" title="Edit"></i>
                                      </button>
                                    </div>
                                    <div class="px-1  tree-btn-1"  *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC2)">
                                          <i class="fa fa-trash" title="Delete"></i>
                                      </button>
                                    </div>
                                  </div>
                                  
                                    </div>
                                    <div class="col-1 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC2.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                                    </div>
                                    <div  class="col-1 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'" >
                                      {{SC2.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                                    
                                    </div>
                                    <div  class="col-1 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'" >
                                      {{SC2.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                      
                                    </div>
                                    <div class="col-1 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      {{SC2.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                                    </div> 
                                    <div class="col-1 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      {{SC2.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                                    </div>
                                    
                                    <div class="col-2 xmiddle" *ngIf="SC2.Study_Unit_Ind=='Y'">
                                      {{SC2.ExamInstanceConcept.Testing_Probability_Type_Code}}
                                    </div>
                                  <div class="col-12" *ngIf="SC2.Data">
                                    <div class="row tree-row tree-row-child " *ngFor="let SC3 of SC2.Data;let m=index"
                                      >
                                      <div class="col-5">
                                          <div class="d-flex">
                                        <div class="px-1 tree-btn-1">
                                          <button type="button" class="tree-btn" (click)="getsubjectData(SC3.ID,'SC4',i,j,k,l,m)"
                                          [disabled]="SC3.Study_Unit_Ind=='Y'" attr.id="plusSC3{{i}}" [hidden]="SC3.ChildNodeExistInd === 'N'">
                                            <i class="fa fa-angle-right" *ngIf="!SC3.Data"></i>
                                            <i class="fa fa-angle-down" *ngIf="SC3.Data"></i>
                                          </button>
                                        </div>
                                        <div class="px-1 tree-btn-1">
                                            <input type="checkbox" [ngClass]="{'orange' : (SC3.Exam_Instance_Concept_Exists_Ind=='Y' && SC3.Study_Unit_Ind=='N')}" [disabled]="SC3.Exam_Instance_Concept_Exists_Ind=='Y' && SC3.Study_Unit_Ind=='N'" [checked]="SC3.Study_Unit_Ind=='Y'" *ngIf="SC3.ChildNodeExistInd === 'Y'" (click)="checkbox(SC3.ID,'SC4',i,j,k,l,m)" class="form-check-input chkbx-size">
                                          </div>
                                        <app-tree-content Text="{{SC3.Name}}" status="{{SC3.Status_Code}}" ID="{{SC3.ID}}"
                                          >
                                        </app-tree-content>
                                        <div class="px-1  tree-btn-1"  *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC3)">
                                              <i class="fa fa-edit" title="Edit"></i>
                                          </button>
                                        </div>
                                        <div class="px-1  tree-btn-1"  *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC3)">
                                              <i class="fa fa-trash" title="Delete"></i>
                                          </button>
                                        </div>
                                      </div>
                                   
                                        </div>
                                        <div class="col-1 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC3.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                                        </div>
                                        <div  class="col-1 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'" >
                                          {{SC3.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                                        
                                        </div>
                                        <div  class="col-1 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'" >
                                          {{SC3.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                          
                                        </div>
                                        <div class="col-1 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          {{SC3.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                                        </div> 
                                        <div class="col-1 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          {{SC3.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                                        </div>
                                        
                                        <div class="col-2 xmiddle" *ngIf="SC3.Study_Unit_Ind=='Y'">
                                          {{SC3.ExamInstanceConcept.Testing_Probability_Type_Code}}
                                        </div>
                                      <div class="col-12" *ngIf="SC3.Data">
                                        <div class="row tree-row tree-row-child" *ngFor="let SC4 of SC3.Data;let n=index"
                                         >
                                          <div class="col-5">
                                              <div class="d-flex">
                                            <div class="px-1 tree-btn-1">
                                              <button type="button" class="tree-btn"
                                              [disabled]="SC4.Study_Unit_Ind=='Y'" (click)="getsubjectData(SC4.ID,'SC5',i,j,k,l,m,n)"
                                                [hidden]="SC4.ChildNodeExistInd === 'N'">
                                                <i class="fa fa-angle-right" *ngIf="!SC4.Data"></i>
                                                <i class="fa fa-angle-down" *ngIf="SC4.Data"></i>
                                              </button>
                                            </div>
                                            <div class="px-1 tree-btn-1">
                                                <input type="checkbox" [ngClass]="{'orange' : (SC4.Exam_Instance_Concept_Exists_Ind=='Y' && SC4.Study_Unit_Ind=='N')}" [disabled]="SC4.Exam_Instance_Concept_Exists_Ind=='Y' && SC4.Study_Unit_Ind=='N'" [checked]="SC4.Study_Unit_Ind=='Y'"  (click)="checkbox(SC4.ID,'SC5',i,j,k,l,m,n)" class="form-check-input chkbx-size">
                                              </div>
                                            <app-tree-content Text="{{SC4.Name}}" status="{{SC4.Status_Code}}" ID="{{SC4.ID}}"
                                              ></app-tree-content>
                                              <div class="px-1  tree-btn-1"  *ngIf="SC4.Study_Unit_Ind=='Y'">
                                                <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC4)">
                                                    <i class="fa fa-edit" title="Edit"></i>
                                                </button>
                                              </div>
                                              <div class="px-1  tree-btn-1"  *ngIf="SC4.Study_Unit_Ind=='Y'">
                                                <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC4)">
                                                    <i class="fa fa-trash" title="Delete"></i>
                                                </button>
                                              </div>
                                          </div>
                                            </div>
                                            <div class="col-1 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'">
                                              <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC4.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                                            </div>
                                            <div  class="col-1 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'" >
                                              {{SC4.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                                            
                                            </div>
                                            <div  class="col-1 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'" >
                                              {{SC4.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                              
                                            </div>
                                            <div class="col-1 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'">
                                              {{SC4.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                                            </div> 
                                            <div class="col-1 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'">
                                              {{SC4.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                                            </div>
                                            
                                            <div class="col-2 xmiddle" *ngIf="SC4.Study_Unit_Ind=='Y'">
                                              {{SC4.ExamInstanceConcept.Testing_Probability_Type_Code}}
                                            </div>

                                          <div class="col-12 " *ngIf="SC4.Data">
                                            <div class="row tree-row tree-row-child" *ngFor="let SC5 of SC4.Data;let o=index"
                                              >
                                              <div class="col-5">
                                                  <div class="d-flex">
                                                <div class=" px-1 tree-btn-1">
                                                  <button type="button" class="tree-btn"
                                                  [disabled]="SC5.Study_Unit_Ind=='Y'" (click)="getsubjectData(SC5.ID,'SC6',i,j,k,l,m,n,o)"
                                                    [hidden]="SC5.ChildNodeExistInd === 'N'">
                                                    <i class="fa fa-angle-right" *ngIf="!SC5.Data"></i>
                                                    <i class="fa fa-angle-down" *ngIf="SC5.Data"></i>
                                                  </button>
                                                </div>
                                                <div class="px-1 tree-btn-1">
                                                    <input type="checkbox" [ngClass]="{'orange' : (SC5.Exam_Instance_Concept_Exists_Ind=='Y' && SC5.Study_Unit_Ind=='N')}" [disabled]="SC5.Exam_Instance_Concept_Exists_Ind=='Y' && SC5.Study_Unit_Ind=='N'" [checked]="SC5.Study_Unit_Ind=='Y'"  (click)="checkbox(SC5.ID,'SC6',i,j,k,l,m,n,o)" class="form-check-input chkbx-size">
                                                  </div>
                                                <app-tree-content Text="{{SC5.Name}}" status="{{SC5.Status_Code}}" ID="{{SC5.ID}}"
                                                  ></app-tree-content>
                                                  <div class="px-1  tree-btn-1"  *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                    <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC5)">
                                                        <i class="fa fa-edit" title="Edit"></i>
                                                    </button>
                                                  </div>
                                                  <div class="px-1  tree-btn-1"  *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                    <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC5)">
                                                        <i class="fa fa-trash" title="Delete"></i>
                                                    </button>
                                                  </div>
                                              </div>
                                              </div>
                                              <div class="col-1 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC5.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                                              </div>
                                              <div  class="col-1 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'" >
                                                {{SC5.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                                              
                                              </div>
                                              <div  class="col-1 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'" >
                                                {{SC5.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                                
                                              </div>
                                              <div class="col-1 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                {{SC5.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                                              </div> 
                                              <div class="col-1 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                {{SC5.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                                              </div>
                                              
                                              <div class="col-2 xmiddle" *ngIf="SC5.Study_Unit_Ind=='Y'">
                                                {{SC5.ExamInstanceConcept.Testing_Probability_Type_Code}}
                                              </div>
                                           
                                            
                                              <div class="col-12 " *ngIf="SC5.Data">
                                                <div class="row tree-row tree-row-child" *ngFor="let SC6 of SC5.Data;let p=index"
                                                  >
                                                  <div class="col-5 d-flex">
                                                    <div class="px-1 tree-btn-1">
                                                      <button type="button" class="tree-btn"
                                                      [disabled]="!SC6.checkedflag"  [hidden]="SC6.ChildNodeExistInd === 'N'">
                                                        <i class="fa fa-angle-right" *ngIf="!SC6.Data"></i>
                                                        <i class="fa fa-angle-down" *ngIf="SC6.Data"></i>
                                                      </button>
                                                    </div>
                                                    <div class="px-1 tree-btn-1">
                                                      <input type="checkbox" [ngClass]="{'orange' : (SC6.Exam_Instance_Concept_Exists_Ind=='Y' && SC6.Study_Unit_Ind=='N')}" [disabled]="SC6.Exam_Instance_Concept_Exists_Ind=='Y' && SC6.Study_Unit_Ind=='N'" [checked]="SC6.Study_Unit_Ind=='Y'"  (click)="checkbox(SC6.ID,'SC7',i,j,k,l,m,n,o,p)" class="form-check-input chkbx-size">
                                                    </div>
                                                    <app-tree-content Text="{{SC6.Name}}" status="{{SC6.Status_Code}}"
                                                      ID="{{SC6.ID}}" >
                                                    </app-tree-content>
                                                    <div class="px-1  tree-btn-1"  *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                      <button type="button" class="tree-btn" (click)="OpenAddEditConceptpopup(SC6)">
                                                          <i class="fa fa-edit" title="Edit"></i>
                                                      </button>
                                                    </div>
                                                    <div class="px-1  tree-btn-1"  *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                      <button type="button" class="tree-btn" (click)="DeleteConceptpopup(SC6)">
                                                          <i class="fa fa-trash" title="Delete"></i>
                                                      </button>
                                                    </div>
                                                    
                                                  </div>
                                                  <div class="col-1 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                    <input type="checkbox"  [disabled]='true' class="form-check-input chkbx-size xymiddle" [checked]="SC6.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'">
                                                  </div>
                                                  <div  class="col-1 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'" >
                                                    {{SC6.ExamInstanceConcept.Minimum_Number_Of_Questions}}
                                                  
                                                  </div>
                                                  <div  class="col-1 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'" >
                                                    {{SC6.ExamInstanceConcept.Maximum_Number_Of_Questions}}
                                                    
                                                  </div>
                                                  <div class="col-1 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                    {{SC6.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code}}
                                                  </div> 
                                                  <div class="col-1 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                    {{SC6.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code}}
                                                  </div>
                                                  
                                                  <div class="col-2 xmiddle" *ngIf="SC6.Study_Unit_Ind=='Y'">
                                                    {{SC6.ExamInstanceConcept.Testing_Probability_Type_Code}}
                                                  </div>
                                                </div>
                                              </div>


                                            </div>
                                          </div>


                                        </div>
                                      </div>


                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>


             
                           
                          </div>
                      </div>

                    
                     
                     
                    
                   
                    </div>
                  <!-- </tbody>
                </table> -->
              </div>
                  
                </div>
              
              </div>
            </div>
           
    </div>

</div>

<div class="modal fade  show Model_popup1" *ngIf="AddEditmodelpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-preview">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Exam Instance Concepts</h6>
        <button type="button" class="close" (click)="CloseAddEditConceptModel()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row">
  
          <div class="col-12" style="height: 65vh !important; overflow: auto;">

  
          
                      
                        <table class="table  table-bordered  table-responsive table-sm">
                          <col>
                          <colgroup span="2"></colgroup>
                          <colgroup span="2"></colgroup>
                          <thead>
                          <tr class="table-secondary table-bordered border-secondary">
                            <th rowspan="2" class="col-md-5 xymiddle tableheaderlabel">Concepts</th>
                            <th rowspan="2" class="col-md-1 xymiddle tableheaderlabel">Include Questions With Images</th>
                            <th colspan="2" scope="col-md-2 colgroup" class="xmiddle tableheaderlabel">No of Questions</th>
                            <th colspan="2" scope="col-md-2 colgroup" class="xmiddle tableheaderlabel">Difficulty Range</th>
                            <th rowspan="2" class="col-md-2 xymiddle tableheaderlabel">Testing probability</th>                   
                          </tr>
                          <tr class="table-secondary table-bordered border-secondary">
                            <th scope="col" class="tableheaderlabel">Minimum</th>
                            <th scope="col" class="tableheaderlabel">Maximum</th>
                            <th scope="col" class="tableheaderlabel">Lower Range</th>
                            <th scope="col" class="tableheaderlabel">Upper Range</th>
                          </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                <app-tree-content Text="{{selectedconceptlist.Name}}" status="{{selectedconceptlist.Status_Code}}" ID="{{selectedconceptlist.ID}}"
                                ></app-tree-content>
                              </th>
                              <th>
                                  <div class="xymiddle">
                                    <input type="checkbox"  class="form-check-input chkbx-size" [checked]="selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind=='Y'" (click)="IncludeQuestioncheckbox()"> 
                                    
                                </div>
                                </th>
                                <th>
                                  <div class="">
                                   <select  class="form-control form-control-sm inputdropdown" [ngClass]="{'orange' :MinimumError }" [(ngModel)]="selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions" #select1 (change)="MinimumNumberOfQuestions(select1.value)">
                                         <option selected value="" hidden></option>
                                         <option class="border-bottom"  *ngFor="let in of counter(100) ;let i='index'" [value]="i" >{{i}}</option>
                                    </select>
                                    
                                </div>
                                </th>
                                <th>
                                  <div>
                                     <select  class="form-control form-control-sm inputdropdown" [ngClass]="{'orange' :MaximumError }" [(ngModel)]="selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions" #select2 (change)="MaximumNumberOfQuestions(select2.value)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom" *ngFor="let in of counter1(100) ;let j='index'" [value]="j" >{{j}}</option>
                                     </select> 

                                </div>
                                </th>
                                <th>
                                  <div>
                                       <select  class="form-control form-control-sm" [ngClass]="{'orange' :LowerError }" [(ngModel)]="selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code"  #select3 (change)="LowerDifficultyLevelTypeCode(select3.value)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom"  *ngFor="let s of getdifficultleveltype;let l=index" [value]="s.Code">{{s.Description}}</option>
                                       </select> 
                                </div>
                                </th>
                                <th>
                                  <div>
                                     <select  class="form-control form-control-sm" [ngClass]="{'orange' :UpperError }" [(ngModel)]="selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code"  #select4 (change)="UpperDifficultyLevelTypeCode(select4.value)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom"  *ngFor="let s of getdifficultleveltype;let l=index" [value]="s.Code">{{s.Description}}</option>
                                     </select> 
                                </div>
                                </th>
                                <th>
                                  <div>
                                   <select  class="form-control form-control-sm" [(ngModel)]="selectedconceptlist.ExamInstanceConcept.Testing_Probability_Type_Code" #select5 (change)="TestingProbabilityTypeCode(select5.value)"> 
                                       <option selected value="" hidden></option>
                                      <option class="border-bottom"   *ngFor="let s of gettesttypevalue;let m=index" [value]="s.Code">{{s.Description}}</option>
                                   </select>
                                </div>
                                </th>
                            </tr>
                          </tbody>
                        </table>
                        
                          <div class="col-12 pb-2">
                         <div class="row">

      <div class="col-12">
        <div class="d-flex">
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" 
              class="btn btn-sm bl-btn" [disabled]='(!selectedconceptlist.ExamInstanceConcept.Testing_Probability_Type_Code||!selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code||!selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code||!selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions||!selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions||LowerError||UpperError||MinimumError||MaximumError)'(click)="Save()">Save</button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button"  class="btn btn-sm bg-light border" (click)="CloseAddEditConceptModel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>       
          </div>
        </div>
                    </div>
                  </div>
          </div>
          
      </div>
      <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="DeleteConceptAlertflag">
        <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border Page-Header p-1 py-0">
              <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
              <button type="button" class="close" (click)="DeleteConceptAlertpopup()"
                style="padding-right: 20px;font-size: 30px;outline: 0;">
                <span aria-hidden="true">&times;</span></button>
            </div>
           
            <div class="modal-body px-3 py-0">
              <div class="row py-2 mx-2 pt-3">
                <div class="col-12">
                  <label>Do you want to delete the Concept ?</label>
                </div>
              </div>
              <div class="row p-1">
                <div class="col-12">
                  <div class="d-flex justify-content-center">
                    <div class="px-1">
                      <button type="button" (click)="DeleteConcept()" class="btn btn-sm bl-btn">Yes</button>
                    </div>
                    <div class="px-1">
                      <button type="button" (click)="CloseDeleteAlertpopup()" class="btn btn-sm bg-light border">No</button>
                    </div>
                    
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
      </div>


